import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../context/LanguageContext';

const PanametricsFocusSection = () => {
  const { t } = useTranslation();
  const { language } = useLanguage();

  return (
    <section className="section section-dark" style={{ position: 'relative', overflow: 'hidden' }}>
      {/* Decorative elements */}
      <div style={{
        position: 'absolute',
        top: '10%',
        right: '-5%',
        width: '300px',
        height: '300px',
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(255, 107, 0, 0.05) 0%, rgba(255, 107, 0, 0) 70%)',
        zIndex: 1
      }}></div>
      
      <div style={{
        position: 'absolute',
        bottom: '10%',
        left: '-5%',
        width: '300px',
        height: '300px',
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(255, 107, 0, 0.05) 0%, rgba(255, 107, 0, 0) 70%)',
        zIndex: 1
      }}></div>
      
      <div className="container" style={{ position: 'relative', zIndex: 2 }}>
        <div className="grid" style={{ 
          display: 'grid',
          gridTemplateColumns: 'repeat(12, 1fr)', 
          gap: '3rem',
          alignItems: 'center'
        }}>
          <div className="col-span-5 md-col-span-12">
            <div className="brand-showcase fade-in" style={{ 
              position: 'relative',
              borderRadius: 'var(--radius-lg)',
              overflow: 'hidden',
              boxShadow: 'var(--shadow-lg)',
              height: '400px',
              backgroundColor: 'rgba(255, 255, 255, 0.1)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              {/* Panametrics logo placeholder */}
              <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='600' height='400' viewBox='0 0 600 400'%3E%3Crect width='600' height='400' fill='%23f3f4f6'/%3E%3Ctext x='300' y='200' font-family='Arial' font-size='36' font-weight='bold' text-anchor='middle' fill='%23FF6B00'%3EPANAMETRICS%3C/text%3E%3Ctext x='300' y='250' font-family='Arial' font-size='24' text-anchor='middle' fill='%23374151'%3EA Baker Hughes business%3C/text%3E%3C/svg%3E")`,
                backgroundSize: 'cover',
                backgroundPosition: 'center'
              }}></div>
              
              {/* Decorative elements */}
              <div style={{
                position: 'absolute',
                top: '20px',
                right: '20px',
                width: '80px',
                height: '80px',
                borderRadius: '50%',
                backgroundColor: 'rgba(255, 107, 0, 0.1)'
              }}></div>
              
              <div style={{
                position: 'absolute',
                bottom: '20px',
                left: '20px',
                width: '60px',
                height: '60px',
                borderRadius: '50%',
                backgroundColor: 'rgba(255, 107, 0, 0.1)'
              }}></div>
            </div>
          </div>
          
          <div className="col-span-7 md-col-span-12">
            <h2 className="fade-in" style={{ 
              fontSize: '2.5rem', 
              marginBottom: '1.5rem',
              position: 'relative',
              paddingBottom: '1.5rem'
            }}>
              {language === 'fr' ? 'Spécialiste Panametrics' : 
               language === 'ar' ? 'متخصص في منتجات بانامتركس' : 
               'Panametrics Specialist'}
              <span style={{
                position: 'absolute',
                bottom: 0,
                left: 0,
                width: '80px',
                height: '4px',
                backgroundColor: 'var(--assco-orange)',
                borderRadius: '2px'
              }}></span>
            </h2>
            
            <p className="fade-in" style={{ 
              fontSize: '1.125rem',
              lineHeight: '1.7',
              marginBottom: '2rem',
              color: 'rgba(255, 255, 255, 0.85)'
            }}>
              {language === 'fr' 
                ? 'ASSCO est fier d\'être un partenaire spécialisé dans les produits Panametrics, offrant une expertise inégalée dans les solutions de mesure de débit, de gaz et d\'humidité pour le secteur Pétrole, Gaz et Industrie.' 
                : language === 'ar' 
                ? 'تفخر ASSCO بكونها شريكًا متخصصًا في منتجات Panametrics، وتقدم خبرة لا مثيل لها في حلول قياس التدفق والغاز والرطوبة لقطاع النفط والغاز والصناعة.' 
                : 'ASSCO is proud to be a specialized partner for Panametrics products, offering unmatched expertise in flow, gas, and moisture measurement solutions for the Oil, Gas and Industry sector.'}
            </p>
            
            <p className="fade-in" style={{ 
              fontSize: '1.125rem',
              lineHeight: '1.7',
              marginBottom: '2rem',
              color: 'rgba(255, 255, 255, 0.85)',
              animationDelay: '0.2s'
            }}>
              {language === 'fr' 
                ? 'Notre équipe possède plus de 20 ans d\'expérience combinée avec les produits Panametrics, garantissant une connaissance approfondie de leurs technologies avancées et de leurs applications spécifiques dans les environnements industriels exigeants.' 
                : language === 'ar' 
                ? 'يمتلك فريقنا أكثر من 20 عامًا من الخبرة المشتركة مع منتجات Panametrics، مما يضمن معرفة عميقة بتقنياتها المتقدمة وتطبيقاتها المحددة في البيئات الصناعية الصعبة.' 
                : 'Our team has over 20 years of combined experience with Panametrics products, ensuring deep knowledge of their advanced technologies and specific applications in demanding industrial environments.'}
            </p>
            
            <div className="expertise-areas fade-in" style={{ 
              marginTop: '2.5rem',
              animationDelay: '0.3s'
            }}>
              <h3 style={{ 
                fontSize: '1.25rem',
                marginBottom: '1.5rem',
                color: 'white'
              }}>
                {language === 'fr' ? 'Domaines d\'expertise' : 
                 language === 'ar' ? 'مجالات الخبرة' : 
                 'Areas of expertise'}
              </h3>
              
              <div className="grid" style={{ 
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                gap: '1.5rem'
              }}>
                <div className="expertise-card" style={{
                  backgroundColor: 'rgba(0, 0, 0, 0.3)',
                  padding: '1.5rem',
                  borderRadius: 'var(--radius-md)',
                  border: '1px solid rgba(255, 255, 255, 0.2)',
                  transition: 'all 0.3s ease'
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = 'var(--shadow-md)';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.3)';
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = 'none';
                }}>
                  <div style={{
                    color: 'var(--assco-orange)',
                    marginBottom: '1rem'
                  }}>
                    <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '32px', height: '32px' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                    </svg>
                  </div>
                  <h4 style={{ 
                    fontSize: '1.125rem',
                    marginBottom: '0.5rem',
                    color: 'white'
                  }}>
                    {language === 'fr' ? 'Mesure de débit' : 
                     language === 'ar' ? 'قياس التدفق' : 
                     'Flow measurement'}
                  </h4>
                  <p style={{ 
                    fontSize: '0.9375rem',
                    color: 'rgba(255, 255, 255, 0.8)'
                  }}>
                    {language === 'fr' ? 'Débitmètres ultrasoniques et à effet vortex' : 
                     language === 'ar' ? 'عدادات التدفق بالموجات فوق الصوتية وتأثير الدوامة' : 
                     'Ultrasonic and vortex flowmeters'}
                  </p>
                </div>
                
                <div className="expertise-card" style={{
                  backgroundColor: 'rgba(0, 0, 0, 0.3)',
                  padding: '1.5rem',
                  borderRadius: 'var(--radius-md)',
                  border: '1px solid rgba(255, 255, 255, 0.2)',
                  transition: 'all 0.3s ease'
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = 'var(--shadow-md)';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.3)';
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = 'none';
                }}>
                  <div style={{
                    color: 'var(--assco-orange)',
                    marginBottom: '1rem'
                  }}>
                    <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '32px', height: '32px' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                  </div>
                  <h4 style={{ 
                    fontSize: '1.125rem',
                    marginBottom: '0.5rem',
                    color: 'white'
                  }}>
                    {language === 'fr' ? 'Analyse de gaz' : 
                     language === 'ar' ? 'تحليل الغاز' : 
                     'Gas analysis'}
                  </h4>
                  <p style={{ 
                    fontSize: '0.9375rem',
                    color: 'rgba(255, 255, 255, 0.8)'
                  }}>
                    {language === 'fr' ? 'Analyseurs d\'hydrogène et d\'oxygène' : 
                     language === 'ar' ? 'محللات الهيدروجين والأكسجين' : 
                     'Hydrogen and Oxygen Analyzers'}
                  </p>
                </div>
                
                <div className="expertise-card" style={{
                  backgroundColor: 'rgba(0, 0, 0, 0.3)',
                  padding: '1.5rem',
                  borderRadius: 'var(--radius-md)',
                  border: '1px solid rgba(255, 255, 255, 0.2)',
                  transition: 'all 0.3s ease'
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
                  e.currentTarget.style.transform = 'translateY(-5px)';
                  e.currentTarget.style.boxShadow = 'var(--shadow-md)';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.backgroundColor = 'rgba(0, 0, 0, 0.3)';
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = 'none';
                }}>
                  <div style={{
                    color: 'var(--assco-orange)',
                    marginBottom: '1rem'
                  }}>
                    <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '32px', height: '32px' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
                    </svg>
                  </div>
                  <h4 style={{ 
                    fontSize: '1.125rem',
                    marginBottom: '0.5rem',
                    color: 'white'
                  }}>
                    {language === 'fr' ? 'Mesure d\'humidité' : 
                     language === 'ar' ? 'قياس الرطوبة' : 
                     'Moisture measurement'}
                  </h4>
                  <p style={{ 
                    fontSize: '0.9375rem',
                    color: 'rgba(255, 255, 255, 0.8)'
                  }}>
                    {language === 'fr' ? 'Analyseurs d\'humidité et de point de rosée' : 
                     language === 'ar' ? 'محللات الرطوبة ونقطة الندى' : 
                     'Moisture and dew point analyzers'}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PanametricsFocusSection;
